import i18next from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend'
import LocalStorageBackend from 'i18next-localstorage-backend';
import localesHash from './locales-hash.json';

export const defaultNS = "main";

i18next
// .use(HttpBackend)
.use(ChainedBackend)
.use(initReactI18next).init({
  lng: "est",
  backend: {
    backends: [
        LocalStorageBackend,
        HttpBackend
    ],
    defaultVersion: localesHash.hash,
    backendOptions: [{
        expirationTime: 7 * 24 * 60 * 60 * 1000 // 7 days, TODO
    }, {
        loadPath: `/locales/i18n/translations/{{lng}}/{{ns}}.json?v=${localesHash.hash}`
    }]
    // loadPath: `http://localhost:3000/locales/i18n/translations/{{lng}}/{{ns}}.json?v=${localesHash.hash}`
  },
  ns: ["main"],
  defaultNS,
  fallbackLng: 'est',
    debug: true,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: ','
    },
    react: { 
        useSuspense: false //   <---- this will do the magic
    }
});

export default i18next;